import colors from './colors';
import fonts from './fonts';

const config = {
  screens: {
    mobile: '480px',
    tablet: '768px',
  },
  colors,
  fonts,
};

export default config;
